import { SkippedCourse, SkippedLesson } from '../../../../api-service/clients/auto-generated-clients';
import { ISkippedItem } from './course-bulk-edit-result-dialog-component';

export interface ICourseBulkEditResult {
  updatedCourseCount: number;
  updatedLessonCount: number;
  skippedCourses?: SkippedCourse[];
}

export interface ILessonBulkEditResult {
  updatedLessonCount: number;
  skippedLessons?: SkippedLesson[];
}

function lessonCountText(count: number) {
  return count === 1 ? '1 lektion' : `${count} lektioner`;
}

export function courseResultSummary(result: ICourseBulkEditResult, includedFutureLessons: boolean) {
  const summary = [`${result.updatedCourseCount} hold blev opdateret.`];
  if (includedFutureLessons) {
    summary.push(result.updatedLessonCount === 1 ? '1 fremtidig lektion fulgte med.' : `${result.updatedLessonCount} fremtidige lektioner fulgte med.`);
  }
  return summary;
}

export function skippedCoursesText(count: number) {
  return `${count} hold blev sprunget over:`;
}

export function skippedCourseItems(result: ICourseBulkEditResult): ISkippedItem[] {
  return (result.skippedCourses ?? []).map(skipped => ({ id: skipped.courseId, name: skipped.courseName, reason: skipped.reason }));
}

export function lessonResultSummary(result: ILessonBulkEditResult) {
  return [`${lessonCountText(result.updatedLessonCount)} blev opdateret.`];
}

export function skippedLessonsText(count: number) {
  return `${lessonCountText(count)} blev sprunget over:`;
}

export function skippedLessonItems(result: ILessonBulkEditResult): ISkippedItem[] {
  return (result.skippedLessons ?? []).map(skipped => ({ id: skipped.lessonId, name: skipped.lessonName, reason: skipped.reason }));
}
